import * as React from 'react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { ComplianceStore } from '../../ComplianceStore'
import { OntarioFederalReport } from './OntarioFederalReport'
import { OntarioSalesReport } from './OntarioSalesReport'
import { OntarioPeriodicReport } from './OntarioPeriodicReport'
import { ONPeriodicReport } from '@getgreenline/homi-shared'
import { OntarioOneClickReport } from './OntarioOneClickReport'
import { Button, Drawer } from 'antd'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  nameOfStore: string
  retailStoreAuthorization: string
  showIndividualReportsSideBar: boolean
}

export class Ontario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      retailStoreAuthorization: '',
      nameOfStore: '',
      showIndividualReportsSideBar: false,
    }
  }

  get individualReportsButton() {
    return (
      <div className='mt-5'>
        <div className='text-muted mb-3'>
          Individual Reports can be downloaded for quality assurance purposes
        </div>
        <Button onClick={() => this.setState({ showIndividualReportsSideBar: true })}>
          Individual Reports
        </Button>
      </div>
    )
  }

  get individualReportsSideBar() {
    const { retailStoreAuthorization, nameOfStore, showIndividualReportsSideBar } = this.state
    const { currentCompanyStore, complianceStore } = this.props

    const sharedReportProps = {
      currentCompanyStore,
      complianceStore,
      nameOfStore,
      retailStoreAuthorization,
    }

    return (
      <Drawer
        visible={showIndividualReportsSideBar}
        onClose={() => this.setState({ showIndividualReportsSideBar: false })}
        placement='right'
        title={<h3 className='mb-0'>Individual Reports</h3>}
        width='auto'
      >
        <div>
          <div>
            <OntarioFederalReport {...sharedReportProps} />
            <div style={{ height: 50 }} />
            <OntarioSalesReport {...sharedReportProps} />
          </div>
        </div>
        <div style={{ height: 50 }} />
        <div>
          <OntarioPeriodicReport
            {...sharedReportProps}
            reportType={ONPeriodicReport.INVENTORY_ADJUSTMENTS}
            reportName='Inventory adjustments'
          />
        </div>
        <div style={{ height: 50 }} />
        <div>
          <OntarioPeriodicReport
            {...sharedReportProps}
            reportType={ONPeriodicReport.DESTRUCTIONS}
            reportName='Destructions'
          />
        </div>
        <div style={{ height: 50 }} />
        <div>
          <OntarioPeriodicReport
            {...sharedReportProps}
            reportType={ONPeriodicReport.INTERSTORE_TRANSFER_IN}
            reportName='Inter-Store Transfer-Incoming'
          />
        </div>
        <div style={{ height: 50 }} />
        <div>
          <OntarioPeriodicReport
            {...sharedReportProps}
            reportType={ONPeriodicReport.INTERSTORE_TRANSFER_OUT}
            reportName='Inter-Store Transfer-Outgoing'
          />
        </div>
      </Drawer>
    )
  }

  render() {
    const { currentCompanyStore, complianceStore } = this.props
    return (
      <>
        <OntarioOneClickReport
          currentCompanyStore={currentCompanyStore}
          complianceStore={complianceStore}
        />
        {this.individualReportsButton}
        {this.individualReportsSideBar}
      </>
    )
  }
}
